import React, { useState, useEffect } from 'react';
import { Box, Fab, Zoom } from '@mui/material';
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';

const ScrollButtons = () => {
    const [showTopButton, setShowTopButton] = useState(false);
    const [showBottomButton, setShowBottomButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            
            // Show top button when scrolled down more than 300px
            setShowTopButton(scrollTop > 300);
            
            // Show bottom button when not at the bottom
            const isAtBottom = scrollTop + windowHeight >= documentHeight - 100;
            setShowBottomButton(!isAtBottom);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const scrollToBottom = () => {
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth'
        });
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 20,
                right: 20,
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                gap: 1
            }}
        >
            {/* Scroll to Top Button */}
            <Zoom in={showTopButton}>
                <Fab
                    color="primary"
                    size="medium"
                    onClick={scrollToTop}
                    sx={{
                        backgroundColor: 'primary.main',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: 'primary.dark',
                        },
                        boxShadow: 3,
                    }}
                    aria-label="Scroll to top"
                >
                    <KeyboardArrowUp />
                </Fab>
            </Zoom>

            {/* Scroll to Bottom Button */}
            <Zoom in={showBottomButton}>
                <Fab
                    color="secondary"
                    size="medium"
                    onClick={scrollToBottom}
                    sx={{
                        backgroundColor: 'secondary.main',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: 'secondary.dark',
                        },
                        boxShadow: 3,
                    }}
                    aria-label="Scroll to bottom"
                >
                    <KeyboardArrowDown />
                </Fab>
            </Zoom>
        </Box>
    );
};

export default ScrollButtons;
